// ABOUTME: Names generated custom CV downloads using the loaded candidate identity.
// ABOUTME: Preserves Unicode names while avoiding filesystem and PDF.js filename delimiters.

export interface CustomCVApplicant {
    companyId?: number | string;
    applicantId?: string;
    name?: string;
}

export const getCustomCVDownloadFileName = (
    name: string | undefined,
    applicantId: string | undefined,
    extension: "pdf" | "docx"
): string => {
    const sanitize = (value: string | undefined) => {
        const characters = Array.from((value || "").trim(), (character) => {
            const code = character.charCodeAt(0);
            return code < 32 || code === 127 ? "-" : character;
        });
        return characters
            .join("")
            .replace(/[\\/:*?"<>|#=]+/g, "-")
            .replace(/\s+/g, " ");
    };
    return (
        ["CVPersonalizado", sanitize(name), sanitize(applicantId)]
            .filter(Boolean)
            .join("_") + `.${extension}`
    );
};
